/**
 * How a space's status looks and what it may be set to.
 *
 * Shared because the operations screen and the units page both render it, and
 * they had drifted: reserved was sky on one and amber on the other, maintenance
 * amber on one and rose on the other. An operator reading the same status in
 * two colours on two screens has to work out whether it is the same status.
 */
export const STATUS_STYLES = {
  available:   { label: 'Available',   className: 'bg-emerald-100 text-emerald-800' },
  occupied:    { label: 'Occupied',    className: 'bg-slate-200 text-slate-700' },
  reserved:    { label: 'Reserved',    className: 'bg-sky-100 text-sky-800' },
  maintenance: { label: 'Maintenance', className: 'bg-amber-100 text-amber-900' },
  retired:     { label: 'Retired',     className: 'bg-slate-100 text-slate-500' },
};

/**
 * `occupied` is deliberately absent: a space becomes occupied by moving a
 * tenant in, and the API rejects it being set directly. Offering it in a
 * dropdown would be offering an action that always fails.
 */
export const EDITABLE_STATUSES = ['available', 'reserved', 'maintenance', 'retired'];

export function StatusPill({ status }) {
  const s = STATUS_STYLES[status] ?? { label: status, className: 'bg-slate-100 text-slate-600' };
  return (
    <span className={`inline-block whitespace-nowrap rounded-full px-2 py-0.5 text-[12px] font-bold ${s.className}`}>
      {s.label}
    </span>
  );
}
